/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen., Ryan Duffy & Warren Dowey
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TaskModel } from '@app/models/task.model';
import { ApiBaseService } from '@app/services/api-services/api-base.service';
import { AuthUserService } from '@app/services/authentication/auth-user-service';
@Injectable({
  providedIn: 'root',
})
export class TasksListService extends ApiBaseService {
  private _tasksList: TaskModel[] = [];
  protected _endpoint = 'tasks';

  constructor(http: HttpClient, authUserService: AuthUserService) {
    super(http, authUserService);
  }

  get tasksList(): TaskModel[] {
    return this._tasksList;
  }

  set tasksList(value: TaskModel[]) {
    this._tasksList = value;
  }
  /**
   *  Warren Dowey
   *
   *  getTaskById
   *
   * : Get an task based on the id by checking the list
   *
   * @param id of type string
   *
   * @returns Void: gets the task with the id that meets the query
   */
  getTaskById(taskId: string): TaskModel {
    for (const task of this.tasksList) {
      if (task.taskId === taskId) {
        return task;
      }
    }
    return null;
  }
  /**
   *  Warren Dowey
   *
   *  getTaskByOwnerId
   *
   * : Get an task based on the slug by checking the list
   *
   * @param slug of type string
   *
   * @returns Void: gets the task with the slug that meets the query
   */
  getTaskByOwnerId(ownerId: string): TaskModel {
    for (const task of this.tasksList) {
      if (task.ownerId === ownerId) {
        return task;
      }
    }
    return null;
  }
  /**
   *  Warren Dowey
   *
   *  getTaskByUserId
   *
   * : Get an task based on the slug by checking the list
   *
   * @param slug of type string
   *
   * @returns Void: gets the task with the slug that meets the query
   */
  getTaskByUserId(userId: string): TaskModel {
    for (const task of this.tasksList) {
      if (task.ownerId === userId) {
        return task;
      }
    }
    return null;
  }
  /**
   *  Warren Dowey
   *
   *  addToList
   *
   * : handles the insert of a new task into the list
   *
   * @param data of type TaskModel
   *
   * @returns Void: inserts a new org into the lsit
   */
  addToList(data: TaskModel): void {
    this.tasksList.push(data);
  }
  /**
   *  Warren Dowey
   *
   *  removeFromList
   *
   * : deletes an task from the list based on ID
   *
   * @param data of type TaskModel
   *
   * @returns Void: deletes a task
   */
  removeFromList(data: TaskModel): void {
    let index = 0;
    for (const task of this.tasksList) {
      if (task.taskId === data.taskId) {
        this.tasksList.slice(index, 1);
      }
      index++;
    }
  }
  /**
   *  Warren Dowey
   *
   *  updateInList
   *
   *  handles the update of an task in the list
   *
   * @param data of type TaskModel
   *
   * @returns Void: update the lsit
   */
  updateInList(data: TaskModel): void {
    for (let task of this.tasksList) {
      if (task.taskId === data.taskId) {
        task = data;
      }
    }
  }
  /**
   *  Warren Dowey
   *
   *  handleData
   *
   *  handles the data from the list by extending the handleData function from the API base service
   *
   * @param data of type TaskModel
   *
   * @returns Void: get the Task data from the Base API query
   */
  protected handleData(data: any) {
    this.tasksList = [];
    let task: TaskModel;
    super.handleData(data);
    for (const item of data) {
      task = new TaskModel();
      this.addToList(task.fromJson(item));
    }
  }
}
